import { mainSiteUrl } from '@/mocks/categories';

export default function CTASection() {
  return (
    <section className="relative w-full min-h-[500px] md:min-h-[600px] flex items-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Wide%20panoramic%20shot%20of%20organized%20modern%20fashion%20retail%20space%2C%20racks%20of%20colorful%20clothing%20arranged%20neatly%2C%20bright%20airy%20boutique%20interior%20with%20natural%20light%20flooding%20through%20large%20windows%2C%20inviting%20sophisticated%20shopping%20atmosphere%2C%20modern%20minimalist%20retail%20design%20with%20warm%20wood%20and%20white%20accents&width=1920&height=1080&seq=cta-bg-v2&orientation=landscape"
        alt="Discover products faster with Hipobuy Spreadsheet"
        title="Explore Hipobuy Spreadsheet products"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-black/45 via-black/20 to-black/35"></div>

      <div className="relative z-10 w-full px-6 md:px-14 py-16 flex flex-col items-start justify-between min-h-[500px] md:min-h-[600px]">
        <h2 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white leading-none max-w-lg mt-8 md:mt-12">
          discover products Faster
        </h2>

        <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between w-full gap-8 mt-auto mb-8 md:mb-12">
          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="whitespace-nowrap inline-flex items-center gap-3 px-6 py-3.5 bg-white rounded-full text-foreground-900 font-semibold text-sm hover:bg-white/95 transition-all duration-200 cursor-pointer"
          >
            hipobuy sheet
            <span className="w-6 h-6 rounded-full bg-foreground-900 flex items-center justify-center">
              <i className="ri-arrow-right-line text-white text-xs"></i>
            </span>
          </a>

          <div className="max-w-sm">
            <p className="text-white/70 text-sm leading-relaxed">
              Start exploring the most comprehensive Hipobuy Spreadsheet product database today and discover
              thousands of curated products across all categories.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}